import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m20.714 18.656-4.09-4.089a.98.98 0 0 0-.696-.287h-.67a8.5 8.5 0 0 0 1.806-5.25A8.53 8.53 0 0 0 8.532.5 8.53 8.53 0 0 0 0 9.03a8.53 8.53 0 0 0 8.532 8.53 8.5 8.5 0 0 0 5.25-1.804v.669c0 .262.103.512.287.697l4.09 4.089a.98.98 0 0 0 1.39 0l1.161-1.16a.99.99 0 0 0 .004-1.395M8.532 14.28c-2.9 0-5.25-2.346-5.25-5.25 0-2.9 2.346-5.25 5.25-5.25 2.9 0 5.25 2.347 5.25 5.25 0 2.9-2.346 5.25-5.25 5.25"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search-icon"}) } }